module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Light.svg?v=c7ab8c1819aa7cf2ba24efc2f6f345f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Light.svg
// module id = 631
// module chunks = 0